
const isProductions = process.env.NODE_ENV === 'production';

export const consoleLog = (string) => !isProductions && console.log(string);

export const consoleError = (string) => !isProductions && console.error(string);